import { useMemo, useState, useEffect } from 'react';
import { func, shape } from 'prop-types';
import styled from 'styled-components';
import DataTable from '../../DataTable';
import Button from '../../StoraEnsoComponents/Button';
import getColumns from './columns';
import { ReactComponent as TrashCanSvg } from '../../../assets/icons/trash-can-solid.svg';

const DeleteIcon = styled(TrashCanSvg)`
  width: 12px;
  height: auto;
  fill: ${({theme}) => theme.colors.white};
`;

const Label = styled.span`
  font-weight: bold;
`;

const TopPanel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: ${({theme}) => theme.colors.bg_gray};
  padding: 8px;
`;

const Actions = styled.div`
`;

// TODO
// - add export button
// - add delete button
function CompartmentDetailGrid({data, onDelete, onCalculate}) {
  const [gridData, setGridData] = useState([]);
  const [totalData, setTotalData] = useState(null);

  const columns = useMemo(() => getColumns({totalData}), [totalData]);

  useEffect(() => {
    setGridData(data.data.slice(0,4));
    setTotalData(data.data[4]);
  }, [data]);

  return (
    <>
      <TopPanel>
        <Label>Compartment ID: {data.id}</Label>
        <Actions>
          <Button kind="negative" size="sm" onClick={onDelete}>
            <DeleteIcon />
          </Button>
        </Actions>
      </TopPanel>

      <DataTable
        columns={columns}
        data={gridData}
        minWidth="1050px"
        loading={false}
        showFooter={true}
        showRecordsInfo={false}
        tableStyle={{
          removeWrapperMargin: true,
          isDense: true,
        }}
      />
    </>
  );
}

CompartmentDetailGrid.propTypes = {
  data: shape({}),
  onDelete: func.isRequired,
}

export default CompartmentDetailGrid;